import List from '~/common/components/Lists/List/index.js';
import ListItem from '~/common/components/Lists/ListItem/index.js';
import Text from '~/common/components/Texts/Text/index.js';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';
import { pixelsToRem } from '~/theme/typography';

import lang from '../language.json';
import BreakdownColumnBox from '../styles/BreakdownColumnBox';

type ContinuanceProps = {
  selectedResult: CalculationResult;
};

export default function Continuance({
  selectedResult,
}: Readonly<ContinuanceProps>) {
  const formulas = selectedResult.formulas.filter((formula) =>
    formula.formulaName.includes('Continuance'),
  );

  if (!formulas.length) {
    return null;
  }

  return (
    <BreakdownColumnBox title={lang.HEADERS.CONTINUANCE}>
      <List as="ul">
        {formulas.map(({ formulaId, formula }) => (
          <Text fontSize={pixelsToRem(14)} as={ListItem} key={formulaId}>
            {formula}
          </Text>
        ))}
      </List>
    </BreakdownColumnBox>
  );
}
